import React from "react";
import "./ProcessSection.css";

/* How we work (brief §15): Discover → Prototype → Engineer → Deploy.
   Copy is descriptive of process only — no invented claims. */
const steps = [
  {
    n: "I",
    title: "Discover",
    text: "We map your domain, data, and workflows to find where AI creates real leverage.",
  },
  {
    n: "II",
    title: "Prototype",
    text: "Rapid working prototypes validate feasibility and value before larger investment.",
  },
  {
    n: "III",
    title: "Engineer",
    text: "Production engineering: data pipelines, models, integration, evaluation, and hardening.",
  },
  {
    n: "IV",
    title: "Deploy",
    text: "We ship, monitor, and iterate and train your team to own what we build together.",
  },
  {
    n: "V",
    title: "Lifecycle",
    text: "CI/CD keeps it alive: automated pipelines, testing, releases, monitoring, and continuous improvement.",
  },
];

const ProcessSection = () => (
  <section
    id="process"
    className="section process"
    style={{ "--section-bg": "var(--bg-secondary)" }}
  >
    <div className="container">
      <div className="section-header">
        <p className="eyebrow">How We Work</p>
        <h2>From an idea to running system</h2>
      </div>

      <ol className="process-steps">
        {steps.map((s) => (
          <li key={s.title} className="process-step">
            <span className="process-numeral" aria-hidden="true">
              {s.n}
            </span>
            <h3 className="process-title">{s.title}</h3>
            <p className="process-text">{s.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default ProcessSection;
